import { render, staticRenderFns } from "./FeeConfig.vue?vue&type=template&id=cd8feba8&scoped=true&"
import script from "./FeeConfig.vue?vue&type=script&lang=js&"
export * from "./FeeConfig.vue?vue&type=script&lang=js&"
import style0 from "./FeeConfig.vue?vue&type=style&index=0&id=cd8feba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8feba8",
  null
  
)

export default component.exports